module.exports = __webpack_public_path__ + "img/20200325135942407.6ec3b515.png";